import {Component,OnInit} from '@angular/core';
import {BalisesService} from "@components/admin/bibliotheque/notifications/balises/balises.service";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {BehaviorSubject} from "rxjs";
import {Store} from "@ngrx/store";
import {AppState} from "@domain/appstate";
import {filterFirstNotNull} from "@share/utils/rxjs-custom-operator";
import {TypeProfil} from "@domain/user/user";


/**
 * Composant d'affichage de la liste des balises
 *
 * @author Lionel Gimenez
 * @date 10/03/2026
 */
@Component({
    host: {'data-test-id': 'balises'},
    selector: 'balises',
    templateUrl: './balises.component.html',
    providers: [BalisesService]
})
export class BalisesComponent implements OnInit {
    /** Indicateur de lecture seule (sous-admin) */
    isReadOnly: boolean = false;

    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     */
    constructor(
        public baliseService: BalisesService,
        private store: Store<AppState>,
    ) {}

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        //Chargement de la liste
        this.baliseService.initListView();

        //Sélection de l'utilisateur connecté
        this.store.select(state => state.session?.user).pipe(filterFirstNotNull()).subscribe(user => {
            //Le sous-admin ne peut pas modifier les balises
            this.isReadOnly = user.fonction === TypeProfil.SOUS_ADMINISTRATEUR;

            //Mise à jour de l'option de lecture seule pour les items
            this.baliseService.listeBaliseView.extraOptions.isReadOnly = this.isReadOnly;

            //Initialisation des actions possibles
            this.listeActions.next([{
                type: TypeAction.PRIMARY,
                icone: 'nio icon-ajouter',
                libelle: 'global.actions.creer',
                doAction: () => this.baliseService.create(),
                isVisible: () => !this.isReadOnly
            }]);

        });
    }
}